import { createAsyncThunk } from "@reduxjs/toolkit";
import asyncInstance from "config/AsyncInstance";
import apiInstance from "config/axiosInstance";

export const GetAllPriceList = createAsyncThunk(
  "price/GetAllPriceList",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("insurance/priceList", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const GetAllServicePriceList = createAsyncThunk(
  "price/GetAllServicePriceList",
  async (body, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.post("insurance/priceList", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const AddPriceService = createAsyncThunk(
  "price/AddPriceService",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("insurance/priceCreate", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const CheckNphiesCode = createAsyncThunk(
  "price/CheckNphiesCode",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/nphiescodeCheck",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const ImportPriceData = createAsyncThunk(
  "price/ImportPriceData",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("insurance/priceImport", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
